// extracted by mini-css-extract-plugin
module.exports = {"resultsWrapper":"styles_resultsWrapper__27zuH","matchList":"styles_matchList__2EN03"};